<template>
  <div id="container">
    <div id="main-can-scroll" @scroll="mScrollEvent">
      <CapPage01 @showApply="showApplyWin"></CapPage01>
      <CapPage02 @showApply="showApplyWin" :style="msy"></CapPage02>
      <!-- <CapPage03></CapPage03> -->
      <CapPage04 :style="psy"></CapPage04>
      <Footer></Footer>
    </div>
    <div id="highest-level" :style="{'height': $store.state.ctrlUnderLevelListHide ? '' : '100%' }" @click="offSelect">
      <s-input :readonly=false seat="Out"></s-input>
    </div>
    <s-apply v-if="isShow" @isShow="ctrlShow" :post="postName" :company="compName"></s-apply>
    <div id="app-toast" class="hide">
      <div class="msg hide"></div>
      <div class="fsh hide">
        <div class="ff f1"><img src="../../assets/icon_finish.png" alt=""></div>
        <div class="h3">提交成功</div>
        <div class="ti">5s后自动关闭</div>
      </div>
    </div>
  </div>
</template>

<script>
import sApply from '@/components/s-apply/s-apply.vue'
import sInput from '@/components/s-input/s-input.vue'
import Footer from '@/components/footer/footer'
import CapPage01 from '@/pages/cap-page-01/cap-page-01'
import CapPage02 from '@/pages/cap-page-02/cap-page-02'
// import CapPage03 from '@/pages/cap-page-03/cap-page-03'
import CapPage04 from '@/pages/cap-page-04/cap-page-04'

export default {
  components: {
    sApply,
    sInput,
    Footer,
    CapPage01,
    CapPage02,
    // CapPage03,
    CapPage04
  },
  data() {
    return {
      isShow: false,
      psy: { display: this.$store.state.plat === "Web" ? "" : "none" },
      msy: { display: this.$store.state.plat === "Mobile" ? "" : "none" },
      postName: '',
      compName: ''
    }
  },
  mounted() {
    this.listenerMainScroll()
    if(this.$store.state.plat === 'Mobile') {
      this.mScrollEvent();
    } else {
      document.getElementById('highest-level').style.display = 'none'
    }
  },
  methods: {
    listenerMainScroll() {
      document.getElementById("main-can-scroll").onscroll = () => {
        // const scrollTop = document.getElementById("main-can-scroll").scrollTop
        // console.log("scrollTop:", scrollTop)
        if (document.getElementById("main-can-scroll").scrollTop == 0) {
          this.$store.state.activeTopTab = 0
        }
      }
    },
    ctrlShow() {
      this.isShow = false
    },
    showApplyWin(pName, comp) {
      if(pName) {
        this.postName = pName
        this.isShow = true
        this.compName = comp
      }
    },
    offSelect() {
      this.$store.commit('setLevelHide', true);
    },
    mScrollEvent() {
      let mSTop = document.getElementById('main-can-scroll').scrollTop
      if(this.$store.state.plat === 'Mobile') {
        let mP1Top = document.querySelector('.page-02').offsetTop
        let mF1Top = document.querySelector('.foot-01').offsetTop - document.body.clientHeight
        if(mSTop > mP1Top && mSTop <= mF1Top) {
          document.getElementById('highest-level').style.display = 'block'
        } else {
          document.getElementById('highest-level').style.display = 'none'
        }
      } else {
        let mP4Top = document.querySelector('.page-04').offsetTop - Math.floor(this.$store.state.plat === 'Web' ? window.innerHeight * 0.07 : 0)
        if(mSTop > window.innerHeight * 0.07) {
          this.$emit('offScroll', false)
        } else {
          this.$emit('offScroll', true)
        }
        if(mSTop >= mP4Top) {
          this.$store.state.activeTopTab = 3
        } else {
          this.$store.state.activeTopTab = 0
        }
        return false;
      }
    }
  },
  watch: {
    isShow: {
      handler: function (newvalue, oldvalue) {
        if(newvalue == true){
          document.body.style.position = "fixed"
        }else{
          document.body.style.position = "static"
        }
        
      },
      immediate: true //值为true的时候一开始监听先自动调用一次
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
  @import "../../components/common/common.less";

  #container {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    #main-can-scroll {
      width: 100%;
      height: 100%;
      .cmScroll(hidden, auto, transparent, 8px);
    }
    #highest-level {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 0;
      height: 0;
      z-index: 1000;
      width: 100%;
      background: rgba(0,0,0,.3);
      // display: none;
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/home/home.vue